import React from 'react';
import { feedback, feedbackV2 } from '@ecosystem/newron-design-system';
import AISignalsCard from './AISignalsCard';

const { Alert } = feedbackV2;

export interface GenAIStatusProps {
  error: string | null;
  aiEnabled: boolean;
  aiLoading: boolean;
  endpoint: string;
  requestId: string;
  insightSummary: { heading: string; text?: string }[] | Record<string, any>;
  onCloseSummary: () => void;
}

export const GenAIStatus: React.FC<GenAIStatusProps> = ({
  error,
  aiEnabled,
  aiLoading,
  endpoint,
  requestId,
  insightSummary,
  onCloseSummary,
}) => (
  <>
    {error && <Alert title={error} type="error" isActionable={true} actionType={feedback.ActionType.DISMISSIBLE} />}
    {aiEnabled && (aiLoading || insightSummary) && (
      <AISignalsCard
        endpoint={endpoint}
        requestId={requestId}
        insightSummary={insightSummary}
        loading={aiLoading}
        onClose={onCloseSummary}
      />
    )}
  </>
);
